import React, { useEffect, useState } from "react"

import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css"

import "react-datepicker/dist/react-datepicker.css"
import PropTypes from "prop-types"
import { Button, Col, Modal, ModalBody, ModalHeader, Row } from "reactstrap"
import LoaderList from "../../components/Common/loaderList"
import { MDBDataTable } from "mdbreact"
import { withTranslation } from "react-i18next"
import { connect } from "react-redux"
import {
  buscarAgendaPorEmpresa,
  cadastrarEmpresaRelatorioAgendado,
  editarEmpresaRelatorioAgendado, removerEmpresaRelatorioAgendado
} from "../../store/auth/profile/actions"
import { Link, withRouter } from "react-router-dom"
import EmpresaRelatorioModal from "./empresa-relatorio-modal"
import { AvForm } from "availity-reactstrap-validation"

const EmpresaRelatorioLista = props => {

  const [modalOpened, setModalOpened] = useState(false)
  const [novoAgenda, setNovoAgenda] = useState({ email: "", tipo: 1, periodo: "month", diaTipo: 1 })
  const [isEditing, setIsEditing] = useState(false)
  const tiposRelatorio = [
    { label: props.t("company-report.tipo.1"), value: 1 },
    { label: props.t("company-report.tipo.2"), value: 2 }
  ]
  const [tiposRestantes, setTiposRestantes] = useState([])
  const [data, setData] = useState({
    columns: [
      { label: props.t("empresa.edicao.codigo.label"), field: "id", size: 40, enableHiding: false },
      { label: props.t("company-report.email"), field: "email", sort: "asc", width: 230 },
      // { label: "Telefone", field: "telefone", sort: "asc", width: 230 },
      { label: props.t("company-report.days.option"), field: "diaOpcao", sort: "asc", width: 100 },
      { label: props.t("company-report.tipo"), field: "tipo", sort: "asc", width: 100 },
      { label: props.t("company-report.days.option"), field: "periodo", sort: "asc", width: 100 },
      { label: props.t("label.actions"), field: "acoes", width: 110 }
    ],
    rows: []
  })
  const [itemRemover, setItemRemover] = useState(null)
  const [modalRemove, setModalRemove] = useState(false)

  useEffect(() => {
    if (Array.isArray(props.empresaAgenda)) {
      const rows = props.empresaAgenda?.map(item => ({
        "id": item.id,
        "email": item.email,
        // "telefone": "",
        "diaOpcao": describeDiaOpcao(item.diaTipo),
        "tipo": describeTipoRelatorio(item.tipo),
        "periodo": describePeriodo(item.periodo),
        "acoes": (
          <div>
            {props.usePermissionEdit && (<>
              <Link to="#" className="me-3 text-primary">
                <i
                  className="mdi mdi-pencil font-size-18 me-3"
                  id="edittooltip"
                  onClick={e => toggle(item, true)}
                  title={props.t("label.actions.edit")}
                />
              </Link>

              <Link to="#" className="text-danger">
                <i className="mdi mdi-delete font-size-18 me-3" id="btnDelete"
                   onClick={() => showConfirmDelete(item)} title={props.t("label.actions.remove")} />
              </Link>
            </>
            )}
          </div>
        )
      }))

      setTiposRestantes(tiposRelatorio.filter(tipo => !props.empresaAgenda.some(agenda => tipo.value === agenda.tipo)))

      setData({
        columns: data.columns,
        rows: rows
      })
    }
  }, [props.empresaAgenda])

  const describeDiaOpcao = diaOpcao => {
    if (diaOpcao === null) {
      return "N/D"
    } else {
      return props.t(`company-report.days.option.${diaOpcao}`)
    }
  }

  const describeTipoRelatorio = tipo => {
    if (tipo === null) {
      return "N/D"
    } else {
      return props.t(`company-report.tipo.${tipo}`)
    }
  }

  const describePeriodo = periodo => {
    if (periodo === null) {
      return "N/D"
    } else {
      return props.t(`company-report.period.${periodo}`)
    }
  }

  const saveAgenda = agendaEmpresa => {
    agendaEmpresa.idEmpresa = props.empresa

    if (isEditing) {
      props.editarEmpresaRelatorioAgendado(agendaEmpresa)
    } else {
      props.cadastrarEmpresaRelatorioAgendado(agendaEmpresa)
    }

    setTimeout(() => props.buscarAgendaPorEmpresa({
      company: props.empresa,
      ignoreCompany: true
    }), 300)

    toggle()
  }

  const toggle = (item, edit) => {
    setIsEditing(edit)

    if (item) {
      setNovoAgenda(item)
    }
    setModalOpened(!modalOpened)
  }

  const showConfirmDelete = item => {
    setItemRemover(item)
    setModalRemove(true)
  }

  const removerRelatorioAgendado = () => {
    props.removerEmpresaRelatorioAgendado({ id: itemRemover.id }, null)
    setModalRemove(false)

    setTimeout(() => props.buscarAgendaPorEmpresa({
      company: props.empresa,
      ignoreCompany: true
    }), 300)
  }

  return <>
    {props.loading ? <LoaderList></LoaderList> :
      <>
        {tiposRestantes.length > 0 && (
          <Button
            type="submit"
            color="primary"
            disabled={!props.usePermissionEdit}
            className="waves-effect waves-light me-2" onClick={(e) => toggle()}>
            {props.t("company-report.modal.new")}
          </Button>
        )
        }
        <div className="table-responsive">
          <MDBDataTable
            responsive
            striped
            bordered
            data={data}
            displayEntries={false}
            info={false}
            paging={false}
            entriesLabel={"Mostrar Registros"}
            infoLabel={["Exibindo", "a", "de", "registros"]}
            noRecordsFoundLabel={"Nenhum registro encontrado"}
            paginationLabel={["Anterior", "Próximo"]}
            searchLabel={"Pesquisar"}
          />
        </div>

        {modalOpened && (
          <EmpresaRelatorioModal
            empresaAgenda={novoAgenda}
            isOpen={modalOpened}
            toggle={() => toggle()}
            isEditing={isEditing}
            saveAgenda={saveAgenda}
            tiposRestantes={isEditing ? tiposRelatorio : tiposRestantes}
          />
        )}

        <Modal isOpen={modalRemove}>
          <ModalHeader tag="h4">{props.t("company-report.modal.remove.title")}</ModalHeader>
          <ModalBody>
            <AvForm
              onValidSubmit={(e, v) => {
                removerRelatorioAgendado()
              }}
            >
              <Row form>
                <Col className="col-12">
                  {props.t("company-report.modal.remove.confirm")}
                </Col>
              </Row>
              <Row style={{ paddingTop: 10 }}>
                <Col>
                  <div className="text-right">
                    <button type="submit" className="btn btn-success save-event">
                      {props.t("label.actions.remove.confirm")}
                    </button>
                    <button
                      type="button"
                      className="btn btn-light ms-2"
                      onClick={e => setModalRemove(false)}
                    >
                      {props.t("label.actions.remove.cancel")}
                    </button>
                  </div>
                </Col>
              </Row>
            </AvForm>
          </ModalBody>
        </Modal>

      </>
    }
  </>
}

EmpresaRelatorioLista.propTypes = {
  loading: PropTypes.bool,
  empresa: PropTypes.any,
  empresaAgenda: PropTypes.array,
  cadastrarEmpresaRelatorioAgendado: PropTypes.func,
  editarEmpresaRelatorioAgendado: PropTypes.func,
  usePermissionEdit: PropTypes.bool
}

const mapStateToProps = state => {
  const {
    empresaAgendaLoading
  } = state.Profile
  return { empresaAgendaLoading }
}

export default withTranslation()(connect(mapStateToProps, {
  cadastrarEmpresaRelatorioAgendado,
  editarEmpresaRelatorioAgendado,
  buscarAgendaPorEmpresa,
  removerEmpresaRelatorioAgendado
})(withRouter(EmpresaRelatorioLista)))

